import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const getCompanyDocumentReminderSettings = async (companyId) => {
  const response = await client.get(
    `docs/company_notification_type/${companyId}`,
    {
      headers: authHeader(),
    }
  );
  return response.data.map((el) => el.id);
};

export const useCompanyDocumentReminderSettingsQuery = (
  companyId,
  options = {}
) => {
  return useQuery(
    queryKeys.companyDocumentReminderSettings(companyId),
    () => getCompanyDocumentReminderSettings(companyId),
    {
      placeholderData: [],
      ...options,
    }
  );
};
